// ═══════════════════════════════════════════════════════════════════════════════
// Budget Validation Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { dateSchema, uuidSchema, nonNegativeNumberSchema } from './common.schema.js';
const budgetKindSchema = z.enum(['main', 'sub']);
// ── Create Budget Input Schema ──
export const createBudgetInputSchema = z.object({
    budgetKind: budgetKindSchema.default('main'),
    parentBudgetId: uuidSchema.optional(),
    startDate: dateSchema,
    endDate: dateSchema,
    amount: nonNegativeNumberSchema,
}).refine((data) => {
    const start = new Date(data.startDate);
    const end = new Date(data.endDate);
    return start <= end;
}, { message: 'End date must be on or after start date', path: ['endDate'] }).refine((data) => (data.budgetKind === 'sub' ? Boolean(data.parentBudgetId) : true), { message: 'Sub budget requires parent budget id', path: ['parentBudgetId'] }).refine((data) => (data.budgetKind === 'main' ? !data.parentBudgetId : true), { message: 'Main budget cannot set parent budget id', path: ['parentBudgetId'] });
// ── Update Budget Input Schema ──
export const updateBudgetInputSchema = z.object({
    startDate: dateSchema.optional(),
    endDate: dateSchema.optional(),
    amount: nonNegativeNumberSchema.optional(),
}).refine((data) => {
    if (data.startDate && data.endDate) {
        const start = new Date(data.startDate);
        const end = new Date(data.endDate);
        return start <= end;
    }
    return true;
}, { message: 'End date must be on or after start date', path: ['endDate'] });
// ── Budget ID Param Schema ──
export const budgetIdParamSchema = z.object({
    id: uuidSchema,
});
// ── Budget Query Schema ──
export const budgetQuerySchema = z.object({
    status: z.enum(['active', 'settled', 'all']).default('all'),
    startDate: dateSchema.optional(),
    endDate: dateSchema.optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
}).refine((data) => {
    if (!data.startDate || !data.endDate) {
        return true;
    }
    const start = new Date(data.startDate);
    const end = new Date(data.endDate);
    return start <= end;
}, { message: 'End date must be on or after start date', path: ['endDate'] });
//# sourceMappingURL=budget.schema.js.map